
<section class=" modulo-reuniao">
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-4">
      <h2>Reuniões</h2>
    </div>    
    <div class="d-flex justify-content-end col-8">
      <div class=" button-header" *ngIf="canEdit">
        <a class="btn btn-reunion btn-primary" [routerLink]="['adicionar/0']">Nova Reunião</a>
      </div>
      <div class="button-header">
        <button class="btn-filters-close font-icon" type="button" (click)="filterActive = !filterActive" [title]="filterActive? 'Fechar filtros':'Abrir Filtros'">
          {{filterActive? 'filter_alt_off': 'filter_alt'}}
        </button>
      </div>
      <div class="button-header" *ngIf="!deleteItens && canEdit">
        <button class="btn-filters-close font-icon" type="button" (click)="deleteItens = true" title="Habilitar deleção dos itens">
          delete
        </button>
      </div>
      <div class="button-header delete-div" *ngIf="deleteItens && canEdit">
        <div class="d-flex">
          <button class="btn btn-delete" type="button" (click)="confirmExcluir()" title="Excluir itens selecionados">
            Excluir
          </button>
          <button class="btn btn-white" type="button" (click)="deleteItens = false" title="Desabilitar deleção dos itens">
            Cancelar
          </button>
        </div>
      </div>
    </div>
  </div>



  <div *ngIf="filterActive" class="mb-2">
    <div class="form_search">
      <div class="m-b">
        <div class="form-group form-filter">
          <h3>Filtros</h3>
        </div>
      </div>
      <form [formGroup]="formFilter">
        <div class="form-group row">
          <div class="col-md-12 m-b">
            <label class="col-sm-12 pb-1">
              <span>Pauta</span>
            </label>
            <input id="filter_description" class="form-control" formControlName="filter_description">
          </div>
          <div class="col-md-3 m-b">
            <label class="col-sm-12 pb-1">Exercício</label>
            <ng-select id="filter_accord_main_id" class="ng-select-alternative" [items]="filters?.filter_accord_main_id" 
              bindLabel="label" bindValue="id" placeholder="Todos" formControlName="filter_accord_main_id">
            </ng-select>
          </div>
          <div class="col-md-3 m-b">
            <label class="col-sm-12 pb-1">Órgão Responsavel</label>
            <ng-select id="filter_agency_host" class="ng-select-alternative" [items]="filters?.filter_agency" 
              bindLabel="label" bindValue="id" placeholder="Todos" formControlName="filter_agency_host">
            </ng-select>
          </div>
          <div class="col-md-3 m-b">
            <label class="col-sm-12 pb-1">Órgão Participante</label>
            <ng-select id="filter_agency_guest" class="ng-select-alternative" [items]="filters?.filter_agency" 
              bindLabel="label" bindValue="id" placeholder="Todos" formControlName="filter_agency_guest">
            </ng-select>
          </div>
          <div class="col-md-3 m-b">
            <label class="col-sm-12 pb-1">Nível de governança</label>
            <ng-select id="filter_governance_level_id" class="ng-select-alternative" [items]="filters?.filter_governance_level_id" 
              bindLabel="label" bindValue="id" placeholder="Todos" formControlName="filter_governance_level_id">
            </ng-select>
          </div>
        </div>
        <div class="col-sm-12 d-flex justify-content-end">
          <div class="me-2">
            <button type="button" class="btn btn-white"  (click)="cleanSearch()">Limpar</button>
          </div>
          <div class="search-button">
            <button type="button" (click)="filterData(true)">Filtrar</button>
          </div>
        </div>
      </form>
    </div>
  </div>

  <div class="system-table mb-1">
    <div class="system-table-conteiner">
      <table>
        <thead>
          <tr>
            <th class="text-center column-delete" *ngIf="deleteItens" title="Selecione os itens que serão excluidos">Excluir</th>
            <th class="text-center">Código</th>
            <th class="text-center">Data</th>
            <th class="title">Pauta</th>
            <th class="text-center">Nível Governança</th>
            <th class="text-center width5"></th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let item of reunioesSearch">
            <tr>
              <td class="text-center delete-cell" *ngIf="deleteItens">
                <input type="checkbox" (click)="setDeleteItem($event)" [id]="item?.id">
              </td>
              <td class="text-center">{{item?.id}}</td>
              <td class="text-center">{{item?.dt_meet | date:'dd/MM/YYYY':'UTC'}}</td>
              <td class="title">
                <a [routerLink]="['editar/'+ item.id]" alt="Editar reunião" title="Editar reunião">
                  {{item?.description}}
                </a>
              </td>
              <td class="text-center">{{item?.governance_level?.name}}</td>
              <td class="text-center">
                <div class="d-flex justify-content-center" *ngIf="!item.reserved">
                  <button class="btn btn-font-icon" *ngIf="canEdit" type="button" [routerLink]="['clonar/'+ item.id]" alt="Clonar reunião" title="Clonar reunião">
                    content_copy
                  </button>
                  <button class="btn btn-font-icon ms-1" type="button" [routerLink]="['apresentacao/'+ item.id]" alt="Apresentar reunião" title="Apresentar reunião">
                    co_present
                  </button>
                  <button class="btn btn-font-icon ms-1" *ngIf="canEdit" type="button" [routerLink]="['editar/'+ item.id]" alt="Editar reunião" title="Editar reunião">
                    edit_square
                  </button>
                </div>
              </td>
            </tr>
          </ng-container>
          <tr *ngIf="!reunioesList?.length" class="border-b-radius">
            <td colspan="6" class="text-center">Nenhuma Reunião Encontrada.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  
  <mat-paginator 
    #paginatorFooter
    (page)="pageChangeEvent($event)"
    [length]="totalRecords"
    [pageSize]="pageSize"
    [pageIndex]="pageIndex"
    [length]="totalRecords"
    [pageSizeOptions]="[5, 10, 20, 50, 100]"
    showFirstLastButtons>
  </mat-paginator>

</section>

<app-loading [loader]="isLoading"></app-loading>
